/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { FinancialSupportDemoCompanyDto } from '../../models/financial-support-demo-company-dto';

export interface FinancialSupportDemoControllerFindOne$Params {
  id: string;
}

export function financialSupportDemoControllerFindOne(http: HttpClient, rootUrl: string, params: FinancialSupportDemoControllerFindOne$Params, context?: HttpContext): Observable<StrictHttpResponse<FinancialSupportDemoCompanyDto>> {
  const rb = new RequestBuilder(rootUrl, financialSupportDemoControllerFindOne.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<FinancialSupportDemoCompanyDto>;
    })
  );
}

financialSupportDemoControllerFindOne.PATH = '/api/financial-support/demo-companies/{id}';
